"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodCopy = void 0;
const onboardingHeroCopy_1 = require("./onboardingHeroCopy");
exports.paymentMethodCopy = {
    header: 'Add a Payment Method',
    cta: 'Add Payment Method',
    heroHeader: onboardingHeroCopy_1.onboardingHeroCopy.header,
    heroSubHeader: onboardingHeroCopy_1.onboardingHeroCopy.subHeader,
    linkPreface: '',
    linkPrompt: '',
    linkHref: '',
    errorTitle: 'Payment Method Error',
    resolutionCta: 'Skip for now',
    resolutionText: 'Please check your payment details and try again.',
    resolutionUrl: '/orders'
};
